import { Component } from "../extends";

export default () =>
	class SiteHamburger extends Component() {
		events() {
			this.el.addEventListener("click", () => this.toggle());
		}

		toggle() {
			this.el.classList.toggle("is-cross");

			if (!this.$Store.isSiteMobileNavOpen) {
				this.enable();
			} else {
				this.disable();
			}
		}

		enable() {
			if (this.$Store.isSiteMobileNavOpen) {
				return;
			}

			this.$Store.isSiteMobileNavOpen = true;
			this.el.setAttribute("aria-label", "Close menu");
			this.el.setAttribute("aria-expanded", "true");

			this.$EE.emit("SiteHamburger:enable");
		}

		disable() {
			if (!this.$Store.isSiteMobileNavOpen) {
				return;
			}

			this.$Store.isSiteMobileNavOpen = false;
			this.el.setAttribute("aria-label", "Open menu");
			this.el.setAttribute("aria-expanded", "false");

			this.$EE.emit("SiteHamburger:disable");
		}
	};
